(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawzeno-finder-story"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.pz-finder').forEach(function(finder){const answer=finder.querySelector('.pz-finder__answer');finder.querySelectorAll('button[data-answer]').forEach(function(button){button.addEventListener('click',function(){finder.querySelectorAll('button[data-answer]').forEach(function(item){item.classList.remove('is-active')});button.classList.add('is-active');answer.textContent=button.dataset.answer})})});

  } catch(e) { console.error(e); }
})();
})();
